import { render } from "./environment.vue?vue&type=template&id=55f634ed&scoped=true"
import script from "./environment.vue?vue&type=script&lang=js"
export * from "./environment.vue?vue&type=script&lang=js"

import "./environment.vue?vue&type=style&index=0&id=55f634ed&scoped=true&lang=less"

import exportComponent from "G:\\B030transformer\\demo (2)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f634ed"]])

export default __exports__